\<template>
    <div style="width: 100%; height: 100%;">
        <NaverMap :zoom-level="zoomLevel" :tile-size-scale="tileSizeScale" :prop-options="options" />
    </div>
</template>

<script>
import {$_NM, $_WC} from '@/confs/common.const.js';
import NaverMap from "@/components/NaverMap.vue";
import NaverMapGeoJsonDrawing from "@/libs/grip.naver.map.geojson.v2.js";

export default {
    name: 'DrawRegionNaverMap',
    props: {
        geojsonUrl: {
            type: String,
            required: false,
            default: $_WC.assets + 'geojson/adarea/' + $_WC.geojsonPath + '/emd.json',
        },
        areaClickEnable: {
            type: Boolean,
            required: false,
            default: true,
        },
        zoomLevel: {
            type: Number,
            default: $_NM.ZOOM_LEVEL,
        },
        tileSizeScale: {
            type: Number,
            default: $_NM.TILE_SIZE_SCALE,
        },
    },
    data() {
        return {
            map: {},
            geoJsonDrawing: {},
            selectedAddongCd: "",
            options: {
                lat: $_WC.responsiveScale === 3 ? $_WC.localGovLatitude : $_WC.localGovLatitude,    // 위도
                lng: $_WC.responsiveScale === 3 ? 127.033313 : $_WC.localGovLongitude,              // 경도
            },
        };
    },
    created() {
        // 지도 로딩 완료 이벤트
        this.$eventBus.$once('NaverMap::map-loaded', map => {
            this.map = map;
            this.geoJsonDrawing = new NaverMapGeoJsonDrawing(map);
            this.drawGeoJson();
        });
    },
    methods: {
        drawGeoJson() {
            this.geoJsonDrawing.setGeoJsonUrl(this.geojsonUrl).setkeyPropNm('adm_code');
            if(this.areaClickEnable) {
                this.geoJsonDrawing.setClickHandle((geoJsonDrawing, prop, event) => {
                    let admCode = prop.adm_code;
                    this.selectArea(admCode, prop);
                })
            }

            this.geoJsonDrawing.setCompletedHandle(geoJsonDrawing => {
                    this.$eventBus.$emit("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing);
            }).drawGeoJson();
        },
        selectArea(admCode, prop) {

            this.noSelectArea();

            if(this.selectedAddongCd !== admCode) {
                this.geoJsonDrawing.setOption(admCode, 'strokeColor', '#777777');
                this.geoJsonDrawing.setOption(admCode, 'strokeWeight', 1);
                this.geoJsonDrawing.setZIndex(admCode, 100);

                this.selectedAddongCd = admCode;
                this.$eventBus.$emit("DrawRegionNaverMap::change-selected-area", prop);
            } else {
                this.selectedAddongCd = $_WC.adGuCode;
                this.$eventBus.$emit("DrawRegionNaverMap::change-selected-area", null);
            }
        },
        noSelectArea() {
            this.geoJsonDrawing.setOptionAll('strokeColor', '#ffffff');
            this.geoJsonDrawing.setOptionAll('strokeWeight', 1);
            this.geoJsonDrawing.setZIndexAll(0);
        },
    },
    components: {
        NaverMap,
    }
}
</script>
